<template>
  <div v-if="!isUserDataLoaded" class="nav--main--right">
    <div class="nav--main--right__account">
      <b-dropdown variant="-txt" text="Loading..." right no-caret></b-dropdown>
    </div>
  </div>
  <div class="nav--main--right" v-else>
    <div class="nav--main--right__account">
      <b-dropdown variant="-txt" right no-caret @show="toggleIcon='chevron-up'" @hide="toggleIcon='chevron-down'" style="color:#838383">
        <template v-slot:button-content>
          {{userData.email}} <font-awesome-icon :icon="toggleIcon" size="xs"></font-awesome-icon>
        </template>
        <b-dropdown-text style="width: 240px;">
          <p class="name"><strong>{{fullName}}</strong></p>
          <!--<p>-->
            <!--<span v-if="hasPlan">{{planName}}</span>-->
            <!--<span v-else>License unactivated – Free</span>-->
            <!--<span v-if="hasPlan && userData.balance !== undefined && userData.balance !== null" class="nav&#45;&#45;main&#45;&#45;right__money__balance">{{userData.balance}}$</span>-->
          <!--</p>-->
          <!--<p v-if="userData.organisation && userData.organisation.length">{{userData.organisation}}</p>-->
          <!--<p class="size-store">{{$t('userMenu.storageAvailable')}}: {{userData.storage}}  {{$t('files.size.gb').toUpperCase()}}</p>-->
          <!--<p class="size-store">{{$t('userMenu.bandwidthAvailable')}}: {{userData.bandwidth}} {{$t('files.size.gb').toUpperCase()}}</p>-->
        </b-dropdown-text>
        <!--<b-dropdown-divider v-if="userData.is_super_admin || userData.is_org_admin"></b-dropdown-divider>-->
        <!--<b-dropdown-item href="/admin/statistics" v-if="userData.is_super_admin">{{$t('userMenu.superAdmin')}}</b-dropdown-item>-->
        <!--<b-dropdown-item href="/workgroup/" v-if="userData.is_org_admin">{{$t('userMenu.organisationAdmin')}}</b-dropdown-item>-->
        <!--<b-dropdown-divider></b-dropdown-divider>-->
        <b-dropdown-divider></b-dropdown-divider>
        <b-dropdown-item to="/release-notes">{{$t('userMenu.releaseNotes')}}</b-dropdown-item>
        <b-dropdown-divider></b-dropdown-divider>
        <!--<b-dropdown-item href="/users/">{{$t('userMenu.myProfile')}}</b-dropdown-item>-->
        <!--<b-dropdown-item to="/color" v-if="isCustomization">{{$t('userMenu.customization')}}</b-dropdown-item>-->
        <!--<b-dropdown-divider></b-dropdown-divider>-->
        <!--<b-dropdown-item v-if="!isUserInOrganisation" @click="handleSwitchToOldTheme(2)">{{$t('userMenu.oldDarkTheme')}}</b-dropdown-item>-->
        <!--<b-dropdown-item v-if="!isUserInOrganisation" @click="handleSwitchToOldTheme(0)">{{$t('userMenu.oldLightTheme')}}</b-dropdown-item>-->
        <!--<b-dropdown-item v-if="!isUserInOrganisation">{{$t('userMenu.newTheme')}} <font-awesome-icon icon="check"></font-awesome-icon></b-dropdown-item>-->
        <!--<b-dropdown-divider v-if="!isUserInOrganisation"></b-dropdown-divider>-->
        <b-dropdown-item to="/account">{{$t('userMenu.profileSettings')}}</b-dropdown-item>
        <b-dropdown-item href="/logout">{{$t('userMenu.logout')}}</b-dropdown-item>
      </b-dropdown>
    </div>
    <!--<span v-if="hasPlan">{{planName}}</span>-->
    <!--<a v-else href="javascript:void(0)" @click="handleOpenLicenseModal">License unactivated – Free</a>-->
    <!--<span v-if="hasPlan && userData.balance !== undefined && userData.balance !== null" class="nav&#45;&#45;main&#45;&#45;right__money__balance">{{userData.balance}}$</span>-->

    <license-activation-modal ref="licenseModal"></license-activation-modal>
  </div>
</template>

<script>
  import {mapGetters, mapActions} from "vuex";
  import UserMixin from "@/mixins/user";
  import LicenseActivationModal from "./LicenseActivationModal";

  export default {
    name: 'user-menu',
    components: {LicenseActivationModal},
    mixins: [UserMixin],
    computed: {
      ...mapGetters(['userData', 'isUserDataLoaded', 'isUserInOrganisation']),

      isCustomization(){
        console.log(this.userData.email)
         return  ['anton@3dprinteros.com', 'andrew@3dprinteros.com', 'george.field@solidsolutions.co.uk'].indexOf(this.userData.email) > -1 ?  true : false;
      },
      fullName() {
        let fullName = this.userData.firstname;
        if (this.userData.lastname) {
          fullName += ' ' + this.userData.lastname;
        }

        return fullName;
      }
    },
    data() {
      return {
        toggleIcon: 'chevron-down'
      }
    },
    methods: {
      ...mapActions(['switchToOldTheme']),

      handleSwitchToOldTheme(theme) {
        this.switchToOldTheme(theme).then(() => {
          window.location.href = '/';
        });
      },

      handleOpenLicenseModal() {
        this.$refs.licenseModal.open();
      }
    }
  }
</script>
<style lang="scss" scoped>
  .size-store{
    font-size: 13px;
  }

</style>
